import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsPage.DropdownFieldEditor', {
    buttonEdit: 'Edit',
    buttonSave: 'Save',
});
